export default "__VITE_ASSET__MGGnzYxy__"